import React, { ChangeEvent } from 'react'
import styled from 'styled-components'
import { ButtonType } from '../../common/global'

const Textarea = styled.textarea<{ maxRows: number, fontSize: number }>`
  margin-top: 10px;
  padding: 10px;
  color: black;
  width: 100%;
  font-size: ${(props) => (props.fontSize + 'px')};
  resize: vertical;
`;

interface InputMultilineProps {
  id: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | ButtonType) => void;
  maxRows?: number;
  fontSize?: number;
  placeholder?: string
  onBlur: (e: ChangeEvent<HTMLTextAreaElement>) => void;
}

const InputMultiline: React.FC<InputMultilineProps> = ({ id, value, onChange, maxRows = 10, fontSize=20, placeholder="", onBlur }) => {
  return (
    <Textarea
      id={id}
      value={value}
      onChange={(e) => onChange({ id: id, value: e.target.value })}
      rows={maxRows}
      maxRows={maxRows}
      placeholder={placeholder || `Insira até ${maxRows} linhas`}
      autoComplete="off"
      fontSize={fontSize}
      onBlur={onBlur}
    />
  );
};

export default InputMultiline;
